<template>
  <InputLabel
    :label="label"
    :name="name"
  />
  <textarea
    v-model="valueProxy"
    class="w-full bg-gray-100 leading-10 px-3 border-b-4"
    :class="{ 'bg-red-100 border-red-200': errorMessages.length > 0 }"
    :disabled="disabled"
    :name="name"
  />
  <div
    v-if="errorMessages.length > 0"
    class="text-sm text-red-400 pt-2"
  >
    {{ errorMessages[0] }}
  </div>
</template>

<script>
import createProxy from '../../../helpers/createProxy';
import InputLabel from './InputLabel.vue';

export default {
  name: 'TextareaInput',

  components: {
    InputLabel,
  },

  props: {
    disabled: {
      default: false,
      type: Boolean,
    },
    errorMessages: {
      default: () => [],
      type: Array,
    },
    label: {
      required: true,
      type: String,
    },
    name: {
      required: true,
      type: String,
    },
    value: {
      default: null,
      type: String,
    },
  },

  computed: {
    /** @type {boolean} */
    valueProxy: createProxy('value'),
  },
};
</script>
